export const getCellColor = (flag) => {
  if (flag === "negative") {
    return "#FF0000";
  } else if (flag === "positive") {
    return "#000000";
  } else {
    return "#D9D9D9";
  }
};